import React, { Component } from 'react';
import { Button, PaddedSection } from '../../atoms';
import ContentConverter from '../../../utils/contentConverter';

import './styles.css';

/**
 * A template for the free trial section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {String} buttonLabel
 * @prop {String} content
 * @prop {String} heading
 * @prop {String} subheading
 * @prop {function} [href]
 *
 * @augments {Component<Props>}
 */
export default class TrialOffer extends Component {
	/**
	* @param {string} content
	*/
	getContent = (content) => new ContentConverter(content).nlToBr().getReactHtml();

	render () {
		const {
			buttonLabel,
			content,
			heading,
			href,
			subheading,
		} = this.props;
		return (
			<PaddedSection className='TrialOffer'>
				<div className='TrialOffer-image' />
				<div className='TrialOffer-content'>
					{subheading ? <h2>{subheading}</h2> : null}
					<h1>{heading}</h1>
					<p dangerouslySetInnerHTML={this.getContent(content)} />
					<Button className='TrialOffer-button Button-arrow-next' href={href}>
						<span>{buttonLabel}</span>
					</Button>
				</div>
			</PaddedSection>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/TrialOffer/TrialOffer.js